export default __webpack_public_path__ + "static/media/D0000.ca6dad9a.png";